<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Admin Attendance Management
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-4">
                <label class="Label">Branch</label>
                <ng-select name="branch" [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="Filter.BranchId" (change)="ComboLoad('Client')" placeholder="Select Branch">
                </ng-select>
            </div>

            <div class="col-md-4">
                <label class="Label">Client</label>
                <ng-select name="client" [items]="Clients" bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                    [(ngModel)]="Filter.ClientId" (change)="ComboLoad('Site')" placeholder="Select Client">
                </ng-select>
            </div>

            <div class="col-md-4">
                <label class="Label">Site</label>
                <ng-select name="site" [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="Filter.SiteId" placeholder="Select Site">
                </ng-select>
            </div>

            <div class="col-md-4">
                <label class="Label">Employee Code</label>
                <input name="Employeecode" type="text" class="form-control" [(ngModel)]="Filter.Code"
                    placeholder="Employee Code" />
            </div>

            <!-- <div class="col-md-3 mt-1">
                <label class="Label">Employee Type: </label>
                <div class="btn-group btn-group-toggle ms-2">
                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                            [(ngModel)]="Filter.EmpType" [ngModelOptions]="{standalone: true}" required>
                        Front Office
                    </label>
                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                        <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                            [(ngModel)]="Filter.EmpType" [ngModelOptions]="{standalone: true}" required>
                        Back Office
                    </label>
                </div>
            </div> -->

            <div class="col-md-auto mt-4">
                <button (click)="AdminAttendanceManagementLoad('GetEmpList')" class="btn btn-primary btn-sm"> Load
                    Employees</button>
            </div>
        </div>

        <div class="row mt-2 mb-2">

            <div class="col-md-4">
                <label class="Label">Employees</label>
                <ng-select name="site" [items]="Employees" bindLabel="FullName" bindValue="EmpMasterID"
                    [(ngModel)]="Filter.EmployeeId" (change)="onEmployeeChange()" placeholder="Select Employee">
                </ng-select>
            </div>

            <!-- <div class="col-md-auto ml-1">
                <label for="FromDateObj" class="Label"> Month Year </label>
                <div class="input-group">
                    <ngb-datepicker #dp name="monthyear" [(ngModel)]="Filter.MonthName"
                        class="month-year small-datepicker"
                        (navigate)="Filter.MonthName= $event.next;onnavigate($event)"></ngb-datepicker>
                </div>
            </div> -->

            <div class="col-md-auto mt-4 pt-1">
                <button (click)="setTab('attendance')" class="btn btn-primary btn-sm"> <i class="bi bi-search"></i> Load
                </button>
            </div>
        </div>

        <!-- <hr> -->


        <div *ngIf="showEmpDetail" class="card employee-card-sm p-2 mt-4">
            <div class="d-flex align-items-center justify-content-between">

                <!-- Left -->
                <div class="d-flex align-items-center">

                    <!-- Avatar -->
                    <div class="avatar-img me-2">
                        <img [src]="Filter.EmpPhoto" alt="Employee Photo">
                        <!-- {{ Filter.EmpPhoto }} -->
                    </div>

                    <!-- Employee Info -->
                    <div style="font-family: 'Helvetica Neue', Helvetica, arial, sans-serif;">
                        <div class="emp-name">{{ Filter.EmpName }}</div>
                        <div class="emp-designation">{{ Filter.EmpCode }}</div>

                        <div class="emp-meta">
                            <span class="me-2">
                                <i class="bi bi-person-badge"></i> {{ Filter.EmpDesignation }}
                            </span>

                            <span>
                                <i class="bi bi-calendar"></i>
                                {{ Filter.EmpJoiningDate }}
                            </span>
                        </div>
                    </div>

                </div>

                <div class="d-flex flex-column align-items-end">

                    <div class="month-label mb-1">
                        March - 2026
                    </div>

                    <div class="d-flex align-items-center gap-2">

                        <div class="stat-box-sm present">
                            <div class="stat-number">{{ stats.present }}</div>
                            <div class="stat-label">Present</div>
                        </div>

                        <div class="stat-box-sm absent">
                            <div class="stat-number">{{ stats.absent }}</div>
                            <div class="stat-label">Absent</div>
                        </div>

                        <div class="stat-box-sm leave">
                            <div class="stat-number">{{ stats.weekoff }}</div>
                            <div class="stat-label">Leave</div>
                        </div>

                    </div>
                </div>

                <!-- Stats -->


            </div>
        </div>



        <div class="card mt-4">
            <div class="tabs">
                <button class="tab d-flex align-items-center" [class.active]="activeTab === 'attendance'"
                    (click)="setTab('attendance')">
                    <img src="../../../../assets/aschedule.png" style="height: 20px; margin-right:4px;">
                    <span style="font-weight: 500;">Attendance</span>
                </button>

                <button class="tab d-flex align-items-center" [class.active]="activeTab === 'leave'"
                    (click)="setTab('leave')">
                    <img src="../../../../assets/leave (1).png" style="height:20px; margin-right:4px;">
                    <span style="font-weight: 500;">Leave</span>
                </button>

                <!-- <button class="tab" [class.active]="activeTab === 'regularization'" (click)="setTab('regularization')">
                    <div class="row" style="line-height: 22px;">
                        <div class="col-3 p-1 m-0 text-center" style="color: #0078D4;">
                            <img src="../../../../assets/immigration.png" style="height: 20px;">
                        </div>
                        <div class="col-9 p-0 m-0" style="font-weight: 500; align-content: center;">
                            Regularization
                        </div>
                    </div>
                </button> -->

                <button class="tab d-flex align-items-center" [class.active]="activeTab === 'regularization'"
                    (click)="setTab('regularization')">
                    <img src="../../../../assets/immigration.png" style="height:20px; margin-right:4px;">
                    <span style="font-weight: 500;">Regularization</span>
                </button>

                <button class="tab d-flex align-items-center" [class.active]="activeTab === 'outdoor'"
                    (click)="setTab('outdoor')">
                    <img src="../../../../assets/outdoor.png" style="height:20px; margin-right:4px;">
                    <span style="font-weight: 500;">Outdoor</span>
                </button>

                <button class="tab d-flex align-items-center" [class.active]="activeTab === 'compoff'"
                    (click)="setTab('compoff')">
                    <img src="../../../../assets/time.png" style="height:20px; margin-right:4px;">
                    <span style="font-weight: 500;">Comp Off</span>
                </button>

                <button class="tab d-flex align-items-center" [class.active]="activeTab === 'compoffconsume'"
                    (click)="setTab('compoffconsume')">
                    <img src="../../../../assets/seo-report.png" style="height:20px; margin-right:4px;">
                    <span style="font-weight: 500;">Comp Off Consume</span>
                </button>

                <button class="tab d-flex align-items-center" [class.active]="activeTab === 'reimbursement'"
                    (click)="setTab('reimbursement')">
                    <img src="../../../../assets/Reimburse.png" style="height:20px; margin-right:4px;">
                    <span style="font-weight: 500;">Reimburse</span>
                </button>

            </div>

            <div class="tab-content">

                <div *ngIf="activeTab === 'attendance'">
                    <div class="mx-1 attendancetab">
                        <app-admin-attendance-view #adminattendanceview [EmployeeId]="Filter.EmployeeId"
                            [EmpName]="Filter.EmpName" [EmpDesignation]="Filter.EmpDesignation"
                            [EmpType]="Filter.EmpType" [EmpPhoto]="Filter.EmpPhoto"
                            [EmpCode]="Filter.EmpCode"></app-admin-attendance-view>
                    </div>
                </div>

                <div *ngIf="activeTab === 'leave'">
                    <div class="mx-1 leavetab">
                        <app-admin-leave-history [EmployeeId]="Filter.EmployeeId" [EmpType]="Filter.EmpType"></app-admin-leave-history>
                    </div>
                </div>

                <div *ngIf="activeTab === 'regularization'">
                    <div class="mx-1 regularizationtab">
                        <app-admin-regularization-history [EmployeeId]="Filter.EmployeeId"
                            [EmpType]="Filter.EmpType"></app-admin-regularization-history>
                    </div>
                </div>

                <div *ngIf="activeTab === 'outdoor'">
                    <div class="mx-1 outdoortab">
                        <app-admin-outdoor-history [EmployeeId]="Filter.EmployeeId" [EmpType]="Filter.EmpType"></app-admin-outdoor-history>
                    </div>
                </div>

                <div *ngIf="activeTab === 'compoff'">
                    <div class="mx-1 compofftab">
                        <app-admin-compoff-history [EmployeeId]="Filter.EmployeeId" [EmpType]="Filter.EmpType"></app-admin-compoff-history>
                    </div>
                </div>

                <div *ngIf="activeTab === 'compoffconsume'">
                    <div class="mx-1 compoffconsumetab">
                        <app-admin-compoff-consume-history [EmployeeId]="Filter.EmployeeId"
                            [EmpType]="Filter.EmpType"></app-admin-compoff-consume-history>
                    </div>
                </div>

                <div *ngIf="activeTab === 'reimbursement'">
                    <div class="mx-1 reimbursementtab">
                        <app-admin-reimbursement-history [EmployeeId]="Filter.EmployeeId"
                            [EmpType]="Filter.EmpType"></app-admin-reimbursement-history>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>